import React, { lazy, useEffect } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import AuthLayout from "../container/profile/authentication/Index";
import MicrosoftLoginPage from "../container/profile/authentication/MicrosoftLoginPage";
import { getItem } from "../utility/localStorageControl";

const MobileNumberScreen = lazy(() =>
  import("../container/profile/authentication/overview/MobileNumber")
);
const Login = lazy(() =>
  import("../container/profile/authentication/overview/SignIn")
);
const SignUp = lazy(() =>
  import("../container/profile/authentication/overview/Signup")
);

const AuthRoot = () => {
  const navigate = useNavigate();

  useEffect(() => navigate("/"));
};

const FrontendRoutes = React.memo(() => {
  const isMicrosoftLoggedIn = getItem("isMicrosoftLoggedIn");
  return (
    <Routes>
      {isMicrosoftLoggedIn ? (
        <Route index element={<MobileNumberScreen />} />
      ) : (
        <Route index element={<MicrosoftLoginPage />} />
      )}
      <Route path="login" element={<Login />} />
      <Route path="register" element={<SignUp />} />
      <Route path="*" element={<AuthRoot />} />
    </Routes>
  );
});

export default AuthLayout(FrontendRoutes);
